import * as React from "react";

import { H2, Paragraph } from "App/global-style";

import Button from "@storeblocks/button";
import { useTexts } from "Components/TextContext";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { BankIdLogin } from "../BankIdLogin";
import { useBankIdLoginHandler } from "../bankIdLoginHooks";
import { Surface } from "./carLogin.styles";

export const LoginWithRegisteredVehicles = ({
  loginOnlyBankId,
}: {
  loginOnlyBankId: boolean;
}): React.ReactElement => {
  const handleBankIdLogin = useBankIdLoginHandler();
  const { getText } = useTexts();

  if (loginOnlyBankId) {
    return (
      <div>
        <H2>{getText("carform.subheader.identifyyourself")}</H2>
        <div style={{ marginBottom: "24px" }}>
          {getText("ingress.loginonlybankid")}
        </div>
        <BankIdLogin handleLogin={() => handleBankIdLogin({ owned: "true" })} />
        <NoBankIdButton />
      </div>
    );
  }

  return (
    <Surface>
      <H2>{getText("carform.subheader.findregisteredcars")}</H2>
      <Paragraph>{getText("ingress.loginbankid")}</Paragraph>

      <BankIdLogin handleLogin={() => handleBankIdLogin({ owned: "true" })} />
    </Surface>
  );
};

const NoBankIdButton = (): React.ReactElement => {
  const [showDetails, toggleDetails] = useState(false);
  const { getText } = useTexts();
  return (
    <div>
      <Button
        className="ingress.whatiscovered"
        variant="text"
        style={{ paddingLeft: "0", marginBottom: "8px" }}
        iconRight={showDetails ? "chevron-up" : "chevron-down"}
        onClick={() => toggleDetails(!showDetails)}
      >
        <p>{getText("ingress.donthavebankid")}</p>
      </Button>
      {showDetails && (
        <div>
          <ReactMarkdown className="with-red-link">
            {getText("ingress.loginonlybankidcontactus")}
          </ReactMarkdown>
        </div>
      )}
    </div>
  );
};
